import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";
import "jquery-libs/jquery.textcomplete";

"use strict";
ko.bindingHandlers.socialinput = {
    init: function(elt, va, bindings, model, context) {
        var action = ko.unwrap(va()),
            selected = bindings().selected ? bindings().selected() : [];
        var callback = (typeof action == "function") ? action : (function(e,ui) {
            e.preventDefault();
            if (action && action.typeof("String") && uly.actions[action]) {
                uly.actions[action](e, $(elt), ui);
            }
            else if(action && action.typeof("String")){
                $(elt).trigger("action:" + action, ui);
            }else if (action && action.typeof("Object")){
            }
        });

        callback = uly.utils.debounced_call(callback);

        $(elt).on('keydown', function(e, ui){
            var antisocial = ko.unwrap(bindings().antisocial);
            if (e.keyCode == 13 || e.keyCode == 10) {
                if ($(elt).hasClass("textcomplete-shown")) {
                    return;
                }
                if ((!antisocial && e.ctrlKey) || (antisocial && !e.ctrlKey)) {
                    var val = elt.value;
                    var setter = function(v) { elt.value = v; }
                    if (typeof val == "undefined" && elt.isContentEditable) {
                        val = elt.innerHTML;
                        setter = function(v) { elt.innerHTML = v; }
                        var sel = window.getSelection();
                        var range = sel.getRangeAt(0);
                        //insert a br in the range and be done with it.
                        var node = document.createElement("br");
                        var textnode = document.createTextNode("\u00a0");
                        range.insertNode(node);
                        range.setStartAfter(node, 0);
                        range.setEndAfter(node, 0);
                        range.collapse(false);
                        range.insertNode(textnode);
                        range.selectNodeContents(textnode);
                        range.deleteContents();
                        sel.removeAllRanges();
                        sel.addRange(range);
                        console.log("innnerHTML=", elt.innerHTML);
                        /*
                        var selection = range.cloneRange();
                        selection.selectNodeContents(range.startContainer);
                        var content = selection.toString();
                        var post = content.substring(range.startOffset);
                        var newSubstr = strategy.replace(value, e);
                        */
                    } else {
                        //not dealing with contenteditable div
                        if (typeof this.selectionStart == "number" && typeof this.selectionEnd == "number") {
                            var start = this.selectionStart;
                            setter(val.slice(0, start) + "\n" + val.slice(this.selectionEnd));
                            this.selectionStart = this.selectionEnd = start + 1;
                        } else if (document.selection && document.selection.createRange) {
                            this.focus();
                            var range = document.selection.createRange();
                            range.text = "\r\n";
                            range.collapse(false);
                            range.select();
                        }
                    }
                } else {
                    $(elt).trigger("change").trigger("blur");
                    uly.reset_timeout();
                    ui = ui || {};
                    ui.model = model;
                    ui.context = context;
                    ui.selected = bindings().selected;
                    callback(e, ui);
                }
            }
        });

    }
};

var user_cache = {};

var default_strategies = {
    "mention":{ // mention strategy
        match: /(^|\s)@(\w*)$/,
        search: function (term, callback) {
            if (user_cache[term]) {
                callback(user_cache[term]);
            } else {
                var f;
                if (term && term.length) {
                    f = "type:contact AND is:user AND "+term;
                } else {
                    f = "type:contact AND is:user";
                }
                uly.api.start().follow("uly:search")
                    .follow("uly:results", { q:{_search_body:f},fields:["title_t", "username_t"],display_mode:"grid"})
                    .follow("item")
                    .then(function(results) {
                        callback(results);
                    }).fail(function(error) {
                        callback([]);
                    });
            }
        },
        replace: function (value) {
            return '$1@' + value.username_t + ' ';
        },
        template: function(value) {
            return "<b>"+value.username_t+"</b>("+value.title+")";
        },
        cache: true
    },
    "command": function(elt, va, bindings, model, context) {
        return {// ulysses command strategy
            match: /(^)\/(\w*)$/,
            search: function(term, callback) {
                console.error("context:", context, "model:", model);
                var actions = ko.unwrap(model.actions).filter(function(a) { return a.cli_enabled; });
                callback($.map(actions, function (action) {
                    var key = action && (action.cli_name || action.name);
                    return action && key && key.indexOf(term) === 0 ? action : null;
                }));
            },
            replace: function(value) {
                return '$1/' + (value.cli_name || value.name) + ' ';
            },
            template: function(value) {
                return "<b><i class='fa "+ value.icon + "'></i> "+(value.cli_name || value.name)+"</b> "+(value.cli_description || value.caption)
            }
        };
    },
    "emoji":{ // emoji strategy
        match: /(^|\s):(\w*)$/,
        search: function (term, callback) {
            var regexp = new RegExp('^' + term);
            var emojies =["smile", "frown"];
            callback($.grep(emojies, function (emoji) {
                return regexp.test(emoji);
            }));
        },
        replace: function (value) {
            return '$1:' + value + ': ';
        }
    }
};

ko.bindingHandlers.activeinput = {
    init: function(elt, va, bindings, model, context) {
        var strategies = ko.unwrap(va());
        if (typeof strategies == "string")
            strategies = strategies.split(",");
        strategies = strategies.map(function(v) {
            var s =  default_strategies[v];
            if (typeof s == "function") {
                return s(elt, va, bindings, model, context);
            }
            return s;
        });
        $(elt).textcomplete(strategies, {
        }).on({
            "textComplete:show":function() {
                $(elt).addClass("textcomplete-shown");
            },
            "textComplete:hide":function() {
                $(elt).removeClass("textcomplete-shown");
            }
        });
    }
};
